import $ from 'jquery';
import Handlebars from 'handlebars';
import throttle from 'lib/throttle';
import extend from 'lib/extend';
import gsap from 'lib/shim/gsap';
import langFromUrl from 'lib/util/langFromUrl';
import tdaConfig from 'lib/util/tda.config';
import anClickManual from 'lib/analytics/click.manual';
import 'lib/helpers/data';
import wwwFuncs from 'lib/tda/www';
import cookies from 'utils/cookies';
import responsive from 'lib/responsive';
import txtNavigation from './navigation.hbs';
import txtLinkTypeLink from './linktype-link.part.hbs';
import txtLinkTypeContainer from './linktype-container.part.hbs';

var __tmplNavigation = Handlebars.compile(txtNavigation);
var __linkTypeRenderers = {};
var __clsContainerExpanded = 'site-nav-link-container-expanded';
var __clsContainerExpanding = 'expanding';
var __clsContainerContracting = 'contracting';
var __selLink = '.site-nav-link';
var __selContainer = '.site-nav-link-container';
var __selContainerBg = '.site-nav-link-container-bg';
var __selContainerExpanded = '.' + __clsContainerExpanded;
var __selExpandedNav = '.site-nav-expanded';
var __selLogoPlaque = '.site-nav-region-plaque';

Handlebars.registerHelper('renderSiteNavLink', function (context, opt) {
  // Determine how we are going to render this link
  var data = Handlebars.createFrame(opt.data);
  var renderer = __linkTypeRenderers[context.type];

  if (!renderer) {
    // console.log('WARNING: Link type is missing a renderer:', context.type, context);
    return;
  }

  // Expose the helper options to the data frame
  data.hash = opt.hash;

  if (opt.fn) {
    // we have a helper body, add the wrap helper
    context = $.extend({}, context, {
      wrap: function (wrapContext, wrapOpt) {
        var wrapData = Handlebars.createFrame(wrapOpt.data);
        wrapData.content = new Handlebars.SafeString(wrapOpt.fn(wrapContext));
        return opt.fn(context, { data: wrapData });
      }
    });
  } else {
    // we don't have a helper body, add a wrap passthrough to the context
    context = $.extend({}, context, {
      wrap: function (wrapContext, wrapOpt) { return wrapOpt.fn(wrapContext); }
    });
  }

  // update correct Spanish text for RAQ here rather than Nav Editor
  if (context.key === 'raq' && langFromUrl() === 'es' && data.tdaCode !== 'WWW') {
    $.extend(true, context, {
      title: 'Pide una cotización'
    });
  }

  var result = renderer(context, $.extend({}, opt, { data: data }));
  return opt.fn ? result : new Handlebars.SafeString(result);
});

function Navigation(model, el, options) {
  this._model = model;
  this.$el = $(el);
  this._options = $.extend({}, Navigation.defaultOptions, options);
  this.initialize(model, el, options);
}

Navigation.defaultOptions = {
  containerAnimationDur: 0.3,
};

$.extend(Navigation.prototype, {
  initialize: function (model, el, options) {
    this.initializePlugins();
    this.bindEvents();

    this._dispatch('onModelLoaded', model);
    this._ignoreScrollEvents = false;
    // console.log('navigation model', model);
  },

  initializePlugins: function () {
    var plugins = [];
    for (var i = 0; i < __plugins.length; ++i) {
      plugins.push(new (Function.prototype.bind.apply(__plugins[i], [null, this, this._options])));
    }
    this._plugins = plugins;
  },

  _dispatch: function (method) {
    var args = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < this._plugins.length; ++i) {
      typeof this._plugins[i][method] === 'function' && this._plugins[i][method].apply(this._plugins[i], args);
    }
  },

  bindEvents: function () {
    this.$el.on('click', '.site-nav-link-type-container > span, .site-nav-link-type-container > a', this.onContainerTitleClicked.bind(this));
    this.$el.on('click', '.site-nav-expanded-hamburger, .site-nav-expanded-menu-background', this.onHamburgerClicked.bind(this));
    this.$el.on('click', '.site-nav-link-container-bg, .site-nav-dropdown', this.onHideContainerViaBg.bind(this));
    this.$el.on('click', '.site-nav-expanded .site-nav-link-type-container > span', this.calculateScrollOverflow.bind(this));
    this.$el.on('click', '.site-nav-logo-actions .menu-hamburger, .site-nav-mobile-hide', this.onMobileHamburgerClicked.bind(this));
    this.$el.on('click', '.bat-covid-close', this.onGenericMsgCloseClicked.bind(this));
    this.$el.on('click', '.bat-covid-close-mobile', this.onGenericMsgMobileCloseClicked.bind(this));

    // KEYDOWN:
    // BAT-4468 keyup fixes FF issue with keydown. the other keydowns habe been passed thus far, consider changing in future.
    this.$el.on('keyup', '.site-nav-link-type-container > span, .site-nav-link-type-container > a', this.onContainerTitleKeyUp.bind(this));
    // KEYDOWN HANDLERS: ADA. BAT-3846
    this.$el.on('keydown', '.site-nav-expanded', this.onMenuKeyDown.bind(this));
    // BAT-4003
    this.$el.on('keydown', '.menu-hamburger', this.onMobileHamburgerKeyDown.bind(this));
    this.$el.on('keydown', '.site-nav-mobile-hide', this.onMobileCloseKeyDown.bind(this));

    $(window).on('resize', throttle(this.calculateScrollOverflow.bind(this), 150));
    this._dispatch('bindEvents');
  },

  getRenderers: function () { return __linkTypeRenderers; },
  getDOMNodes: function (link) { return this.$el.find('li[data-linkId="' + link.id + '"]'); },

  walk: function (link, fn, path) {
    if (typeof link === 'function') {
      path = fn;
      fn = link;
      link = this._model;
    }

    if (!link.links) {
      return;
    }

    path || (path = []);
    path.push(link);

    for (var i = 0; i < link.links.length; ++i) {
      var xform = fn(link.links[i], path, i);
      if (xform !== void 0) {
        link.links[i] = xform;
      }
      this.walk(link.links[i], fn, path);
    }

    path.pop();
  },

  getPathRegion: function (path) {
    for (var i = 0; i < path.length; ++i) {
      if ('region' === path[i].type) {
        return path[i];
      }
    }

    return false;
  },

  pathToString: function (path, link) {
    return path.map(function (l) { return l.id; }).concat(link ? [link.id] : []).join('/');
  },

  linkByPathString: function (pathStr) {
    var path = pathStr.split('/');
    var scope = [this._model];
    var link = false;

    for (var i = 0; i < path.length; ++i) {
      if (!scope) {
        return false;
      }

      var next;

      for (var j = 0; j < scope.length; j++) {
        if (scope[j].id == path[i]) {
          next = scope[j];
          break;
        }
      }

      if (!next) {
        return false;
      }

      link = next;
      scope = next.links;
    }

    return link;
  },

  onHideContainerViaBg: function (e) {
    var $target = $(e.target);

    if ($target.closest('.site-nav-dropdown-content').length > 0) return;

    var self = this;
    var $parent = $(e.currentTarget).closest(__selContainer);

    if ($parent.data('nav-exclusive')) {
      var exclusiveDomain = $parent.data('nav-domain');
      if (exclusiveDomain) {
        $('[data-nav-domain="' + exclusiveDomain + '"]').children(__selContainerExpanded).each(function () {self.hideContainer($(this));});
      } else {
        $parent.children(__selContainerExpanded).each(function () {self.hideContainer($(this));});
      }
    }
  },

  showContainer: function ($link) {
    var self = this;
    var $parent = $link.closest(__selContainer);

    if ($parent.data('nav-exclusive')) {
      var exclusiveDomain = $parent.data('nav-domain');
      if (exclusiveDomain) {
        $('[data-nav-domain="' + exclusiveDomain + '"]').children(__selContainerExpanded).each(function () {self.hideContainer($(this));});
      } else {
        $parent.children(__selContainerExpanded).each(function () {self.hideContainer($(this));});
      }
    }

    $link.addClass(__clsContainerExpanded)
      .addClass(__clsContainerExpanding);

    wwwFuncs.nationalLinks.init();
    wwwFuncs.nationalForms.init();

    var animDurInSec = this._options.containerAnimationDur;
    var targetSel = $link.data('nav-target') || __selContainer;
    var bgSel = $link.data('nav-target-bg') || __selContainerBg;
    var targetHeightSel = $link.data('nav-height-source');
    var $target = $link.children(targetSel);
    var $container = $link.children(__selContainer);
    var $targetBg = $link.children(bgSel);
    var targetHeight = $target.height();
    var isExpandedNav = $link.closest(__selExpandedNav).length > 0;

    if (targetHeightSel) {
      targetHeight = $(targetHeightSel).height();
    }

    // BAT-5017 FOCUS TRAP FIX
    $('.site-nav-expanded .last-nav-option').off().on('keydown', function (e) {
      var el = $(e.target);
      var allContainerBtns = $('#dd-expanded .container-button');
      var containerBtn = el.parent().parent().parent().find('.container-button');
      var btnIndex = $('#dd-expanded .container-button').index(containerBtn);
      var aParentLI = el.parent().parent().parent().parent().parent();

      if (e.keyCode === 9 && !e.shiftKey) {
        var lastElement = $('#dd-expanded-container.site-nav-link-container').children().last();
        var isLastLinkInContainer = lastElement.find('a').attr('data-id') === el.attr('data-id');
        if ((btnIndex === (allContainerBtns.length - 1) && aParentLI.siblings().length < 1) || isLastLinkInContainer) {
          e.preventDefault();
          $('.site-nav-expanded-hamburger').focus();
        }
      }
    });

    $('.site-nav-expanded .last-nav-expanded-option').off().on('keydown', function (e) {
      var el = $(e.target);
      var allContainerBtns = $('#dd-expanded .container-button');
      var visibleButtons = $('#dd-expanded .container-button:visible');
      var isContainerBtn = el.hasClass('container-button');
      var parentLI = el.parent().parent().parent().parent();

      if (isContainerBtn) {
        var btnIndex = $('#dd-expanded .container-button').index(el);
        if (btnIndex === 0 && visibleButtons.length === 1) {
          // only one element button is visile, like "Featured" and the container link is closed.
          if (el.parent().parent().find('.site-nav-link-container').css('display') === 'none') {
            if (e.keyCode === 9 && !e.shiftKey) {
              e.preventDefault();
              $('.site-nav-expanded-hamburger').focus();
            }
          }
        }
        if (btnIndex === (allContainerBtns.length-1)) {
          var linkContainer = el.parent().parent().find('.site-nav-link-container');
          if (linkContainer.css('display') === 'none' && e.keyCode === 9 && !e.shiftKey && !parentLI.siblings().length) {
            e.preventDefault();
            $('.site-nav-expanded-hamburger').focus();
          }
          // $(this).parents('.site-nav-link-container-expanded').find('.container-button:first').focus();
        }
      }
    });

    var timeline = new gsap.TimelineLite({
      onComplete: function () {
        $link.trigger('navigationexpanded');

        if (isExpandedNav) {
          self.calculateScrollOverflow(0);
        }
      },

      onStart: function () {
        $link.trigger('navigationexpanding');
      }
    });

    if (isExpandedNav) {
      timeline.set('.site-nav-expanded-overflow-indicator', { visibility: 'hidden' });
    }

    timeline
      .set($target, { overflow: 'hidden', minHeight: 'auto' })
      .fromTo($target, animDurInSec, { height: 0 }, {
        height: targetHeight,
        clearProps: 'all'
      });

    if (isExpandedNav) {
      timeline.set('.site-nav-expanded-overflow-indicator', { visibility: 'inherit' });
    }

    timeline
      .set($link, { className: '-=' + __clsContainerExpanding })
      .staggerFrom($container.children(), 0.3, { autoAlpha: 0 }, 0.1, 0);

    if ($targetBg.length > 0) {
      timeline.fromTo($targetBg, animDurInSec, { autoAlpha: 0 }, { autoAlpha: 1 }, 0);
    }

    var $mirrorTarget = $link.closest('[data-nav-mirror-height]');
    if ($mirrorTarget.length > 0) {
      this.mirrorHeight(timeline, $mirrorTarget, targetHeight);
    }

    if ($link.hasClass('site-nav-link-type-container')) {
      $($link).find('.container-button').attr('aria-expanded', 'true');
    }

    if ($link.hasClass('site-nav-link-type-vehicles')) {
      $($link).find('#nav-vehicles').attr('aria-expanded', 'true');
      $('body').addClass('container-opened');
    }
  },

  hideContainer: function ($link) {
    var animDurInSec = this._options.containerAnimationDur;
    var targetSel = $link.data('nav-target') || __selContainer;
    var bgSel = $link.data('nav-target-bg') || __selContainerBg;
    var $parent = $link.closest(__selContainer);
    var $target = $link.children(targetSel);
    var $targetBg = $link.children(bgSel);
    var targetHeight = $target.height();
    var targetOffset = $target.offset();
    var isExpandedNav = $link.closest(__selExpandedNav).length > 0;
    var self = this;

    var timeline = new gsap.TimelineLite({
      onComplete: function () {
        $link.trigger('navigationcollapsed');

        if (isExpandedNav) {
          self._ignoreScrollEvents = false;
        }
      }
    });

    timeline
      .set($link, { className: '+=' + __clsContainerContracting })
      .set($target, { overflow: 'hidden' })
      .to($target, animDurInSec, { minHeight: 0, height: 0, clearProps: 'all' })
      .set($link, { className: '-=' + __clsContainerExpanded })
      .set($link, { className: '-=' + __clsContainerContracting });

    if ($targetBg.length > 0) {
      timeline.to($targetBg, animDurInSec, { autoAlpha: 0 }, 0);
    }

    if (isExpandedNav) {
      this.calculateScrollOverflow(-targetHeight);
      this._ignoreScrollEvents = true;
    }

    var $mirrorTarget = $link.closest('[data-nav-mirror-height]');
    if ($mirrorTarget.length > 0) {
      this.mirrorHeight(timeline, $mirrorTarget, -targetHeight);
    }

    if ($link.hasClass('site-nav-link-type-container')) {
      $($link).find('.container-button').attr('aria-expanded', 'false');
    }

    if ($link.hasClass('site-nav-link-type-vehicles')) {
      $($link).find('#nav-vehicles').attr('aria-expanded', 'false');
      $('body').removeClass('container-opened');
    }
  },

  mirrorHeight: function (timeline, $mirror, deltaHeight) {
    var $target = $($mirror.data('nav-mirror-height'));
    var targetHeight = $target.data('mirror-target-height') + deltaHeight;

    $target.data('mirror-target-height', targetHeight);
    timeline.to($target, this._options.containerAnimationDur, { minHeight: targetHeight }, 0);
  },

  onContainerTitleKeyUp: function (e) {
    if (e.keyCode !== 32 && e.keyCode !== 13) {
      return;
    }
    // ADA, ALLOW SPACE BAR TO OPEN AND CLOSE THE CONTAINERS

    $(e.target).trigger('click');
    // this.onContainerTitleClicked(e);
  },

  onContainerTitleClicked: function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    var $link = $target.closest(__selLink);

    if ($link.is(__selContainerExpanded)) {
      // ADA BAT-4663 use this trick to get the SRT to read
      // the hamburger menu and close button propertly
      this.hideContainer($link);
      $($link).parent().attr('aria-expanded', 'false');
    } else {
      $($link).parent().attr('aria-expanded', 'true');
      this.showContainer($link);
    }
  },

  // BAT-3846: enable the menu button to be keyboard controlled
  onMenuKeyDown: function (event) {
    var $et = $(event.target);
    var isHamburger = $et.is('.site-nav-expanded-hamburger');
    // console.log('MENU KEY DOWN isHamburger', isHamburger, '\nkeycode:', event.keyCode, '\ntarg',event.target, '\ncurr', event.currentTarget );
    /*
      THE HAMBURGER WILL TOGGLE STATE OF MENU.
      CONTAINERS WILL EXPAND/COLLAPSE.
      LINKS WILL FIRE.
    */
    if (event.keyCode === 32 || event.keyCode === 13) {
      if (isHamburger) {
        $('.site-nav-expanded-hamburger').trigger('click');
      } else {
        if ($et.is('span') && $et.attr('role') === 'button') {
          $et.trigger('click');
        }
        if ($et.is('a') && $et.attr('href')) {
          if ($et.attr('target') === '_blank') {
            window.open($et.attr('href'), '_blank');
          } else {
            window.location.href = $et.attr('href');
          }
        }
      }
      event.preventDefault();
    }
  },

  // BAT-4003
  onMobileCloseKeyDown: function (event) {
    var $et = $(event.target);
    var isMobileClose = $et.is('.site-nav-mobile-hide');
    if (event.keyCode === 32 || event.keyCode === 13) {
      if (isMobileClose) {
        this.onMobileHamburgerClicked(event);
      }
    }
  },

  // BAT-4003
  onMobileHamburgerKeyDown: function (event) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      this.onMobileHamburgerClicked(event);
    }
  },

  onHamburgerClicked: function (e) {
    // See if we need to trigger a data layer event
    var $target = $(e.currentTarget);
    var $link = $target.closest(__selLink);

    if (!$link.is(__selContainerExpanded)) {
      anClickManual(this.$el, $target);
    }
    this.onContainerTitleClicked(e);
  },

  onMobileHamburgerClicked: function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.$el.is('.site-nav-mobile-fixed')) {
      // mobile menu closing
      this.$el.removeClass('site-nav-mobile-fixed');
      gsap.TweenLite.to(__selLogoPlaque, 0.3, { autoAlpha: 1 });
      $('#mobMenuZip').attr('tabIndex', '-1');// BAT-4003
      $('.site-nav-mobile-hide').attr('tabIndex', '-1');// BAT-4003
      $('.site-nav-logo-actions .menu-hamburger').show();
      this.hideContainer(this.$el.find('.site-nav-mobile'));
    } else {
      // mobile menu opening.
      this.$el.addClass('site-nav-mobile-fixed');
      gsap.TweenLite.to(__selLogoPlaque, 0.3, { autoAlpha: 0 });
      $('#mobMenuZip').attr('tabIndex', '0');// BAT-4003
      $('.site-nav-mobile-hide').attr('tabIndex', '0');// BAT-4003
      $('.site-nav-logo-actions .menu-hamburger').hide();
      this.showContainer(this.$el.find('.site-nav-mobile'));
      setTimeout(function () {
        $('.site-nav-mobile-hide').focus();
      }, 600);
    }
  },

  onGenericMsgCloseClicked: function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('#bat-generic-msg').hide();
    $('.main-header-offers').css('marginTop', '-=50');
    $('.site-nav-region-plaque-container').css('top', '-=50');
    cookies.setItem('global_notice', 'hide', '', '/', cookies.getCrossDomainCookieDomain());
  },

  onGenericMsgMobileCloseClicked: function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('#bat-generic-msg-mobile').hide();
    $('.site-nav-mobile').css('padding-top', '0px');
    cookies.setItem('global_notice', 'hide', '', '/', cookies.getCrossDomainCookieDomain());
  },

  hideGenericMsg: function () {
    $('#bat-generic-msg').hide();
    $('#bat-generic-msg-mobile').hide();
    $('.site-nav-mobile').css('padding-top', '0px');
  },

  checkGlobalNoticeCookie: function () {
    if (cookies.getItem('global_notice') === 'hide') {
      this.hideGenericMsg();
    } else if (responsive() !== 'sm') {
      $(document).ready(function () {
        $('.main-header-offers').css('marginTop', '+=50');
        $('.site-nav-region-plaque-container').css('top', '+=50');
      });
    }
  },

  calculateScrollOverflow: function (offset) {
    if (this._ignoreScrollEvents) return;

    if (typeof offset !== 'number') {
      offset = 0;
    }

    var scrollEl = this.$el.find('.site-nav-expanded-menu-scroll').get(0);
    var $indicator = this.$el.find('.site-nav-expanded-overflow-indicator');
    if ((scrollEl.scrollHeight + offset) > scrollEl.offsetHeight && (scrollEl.scrollTop + scrollEl.offsetHeight) / (scrollEl.scrollHeight + offset) < 0.98) {
      $indicator.fadeIn();
    } else if (scrollEl.offsetHeight >= scrollEl.scrollHeight + offset) {
      $indicator.hide();
    } else {
      $indicator.fadeOut();
    }
  },

  getRegionByKey: function (key) {
    // return model.links.find(function(k) { return k === key });
    for (var i = 0; i < this._model.links.length; ++i) {
      if (this._model.links[i].key === key) {
        return this._model.links[i];
      }
    }
  },

  removeRegionByKey: function (key) {
    for (var i = 0; i < this._model.links.length; ++i) {
      if (this._model.links[i].key === key) {
        this._model.links.splice(i, 1);
      }
    }
  },

  createRegion: function (id, name) {
    return {
      id: id,
      type: 'region',
      key: id,
      title: name,
      links: [],
    };
  },

  getDefaultTemplateContext: function () {
    return {};
  },

  getDefaultTemplateData: function () {
    return {
      nav: this,
      lang: langFromUrl(),
      tdaCode: this._options.tdaCode,
      regionName: this._options.regionName,
      regionSubtitle: this._options.regionSubtitle,
      i18n: this._options.i18n,
      siteContext: tdaConfig.site.context_url,
    };
  },

  renderInContext: function (tmpl, tmplCtx, opt) {
    var ctx = $.extend({}, this.getDefaultTemplateContext(), tmplCtx);
    opt || (opt = {});
    opt.data = $.extend({}, this.getDefaultTemplateData(), opt.data);
    return tmpl(ctx, opt);
  },

  render: function () {
    // The model root is a segment, it's regions are the primary regions
    // of the nav

    var ctx = this.getDefaultTemplateContext();
    ctx.regions = {};

    this._model.links.forEach(function (link) {
      if (link.type === 'region') {
        ctx.regions[link.key || link.id] = link.links;
      }
    });

    // Let start with the utility region
    var region = this.getRegionByKey('utility');
    ctx.utilityLinks = region.links;

    // Primary links
    region = this.getRegionByKey('primary');
    ctx.primaryLinks = region.links;

    ctx.mobileLinks = region.links.slice(0, 3);

    // Expanded
    region = this.getRegionByKey('expanded');
    ctx.expandedLinks = region.links;

    // console.log('built nav context', ctx);

    this.$el.html(__tmplNavigation(ctx, { data: this.getDefaultTemplateData() }));

    // Scroll events don't bubble so delegate doesn't work, need to attach here
    this.$el.find('.site-nav-expanded-menu-scroll').on('scroll', throttle(this.calculateScrollOverflow.bind(this), 150));

    // Find the expanded menu and check if there is a single container, if so, pre-expand it.
    var $expandedContainer = $('.site-nav-expanded .site-nav-expanded-menu-scroll > .site-nav-link-container');
    if ($expandedContainer.children().length == 1) {
      $expandedContainer.children('.site-nav-link-type-container').addClass('site-nav-link-container-expanded');
    }

    var $expandedMainMobileMenu = $('.main-mobile-nav-wrapper > .site-nav-mobile-menu > .site-nav-expanded-menu-content .site-nav-link-type-container');
    $expandedMainMobileMenu.each(function() {
      var labelText = $(this).find('> span > .container-button').text();
      $(this).find('> .site-nav-link-container').prepend('<li class="close-submenu">'+labelText+' <button class="site-nav-mobile-hide" tabindex="0"><i class="icon icon-close-modal using-mouse" aria-hidden="true"></i><span class="reader-hidden-text">Close Menu</span></button></li>');
      $(this).find('> .site-nav-link-container li:first-child').click(function() {
        $(this).parent('.site-nav-link-container').parent('.site-nav-link-type-container').removeClass('site-nav-link-container-expanded');
      });
    });

    $('.close-submenu .site-nav-mobile-hide, .site-nav-mobile-top-bar .site-nav-mobile-hide').click(function() {
      window.scrollTo(0, 0);
      $(this).parents('body').removeClass('no-overflow');
      $(this).parents('body').find('.main-mobile-nav-wrapper .site-nav-link-container-expanded').removeClass('site-nav-link-container-expanded');
      $(this).parents('.main-mobile-nav-wrapper').removeClass('get-in-front');
    });

    $('.main-mobile-nav-wrapper .site-nav-expanded-menu-content > .site-nav-link-container > li > ul > .close-submenu').click(function() {
      $(this).parents('.main-mobile-nav-wrapper').removeClass('get-in-front');
    });

    var $expandedMobTypeContainer = $('.main-mobile-nav-wrapper .site-nav-link-container > li.site-nav-link-type-container > span');
    $expandedMobTypeContainer.click(function() {
      $expandedMobTypeContainer.parents('.main-mobile-nav-wrapper').addClass('get-in-front');
    });

    $('.main-mobile-nav-wrapper').parents('.site-nav').find('.menu-hamburger').click(function() {
      $(this).parents('body').addClass('no-overflow');
    });

    // add class to element by url (using for icons on first level of expanded mobile navigation - type link)
    var $firstLevelExpNavMob = $('.main-mobile-nav-wrapper > .site-nav-expanded-menu > .site-nav-expanded-menu-content > .site-nav-link-container > .site-nav-link');
    $firstLevelExpNavMob.each(function() {
      var dataUrlVal = $(this).find('> a').attr('href');
      if (typeof dataUrlVal !== 'undefined') {
        if(dataUrlVal.includes("dealers")) {
          $(this).addClass('find-a-dealer');
        }
        else if (dataUrlVal.indexOf("request-a-quote") >= 0) {
          $(this).addClass('request-a-quote');
        }
        else if (dataUrlVal.indexOf("inventory") >= 0) {
          $(this).addClass('inventory');
        }
        else if (dataUrlVal.indexOf("vehicles") >= 0) {
          $(this).addClass('vehicles');
        }
        else if (dataUrlVal.indexOf("featured") >= 0) {
          $(this).addClass('featured');
        }
        else if (dataUrlVal.indexOf("contact-dealer") >= 0) {
          $(this).addClass('contact-a-dealer');
        }
        else if (dataUrlVal.indexOf("dealerships") >= 0) {
          $(this).addClass('dealerships');
        }
        else if (dataUrlVal.indexOf("/offers") >= 0) {
          $(this).addClass('offers');
        }
        else if (dataUrlVal.indexOf("schedule-a-test-drive") >= 0) {
          $(this).addClass('schedule-a-test-drive');
        }
        else if (dataUrlVal.indexOf("payment-estimator") >= 0) {
          $(this).addClass('payment-estimator');
        }
        else if (dataUrlVal.indexOf("trade-in-value") >= 0) {
          $(this).addClass('trade-in-value');
        }
        else if (dataUrlVal.indexOf("certified") >= 0 || dataUrlVal.indexOf("certificados") >= 0) {
          $(this).addClass('certified-used');
        }
        else if (dataUrlVal.indexOf("favorites") >= 0) {
          $(this).addClass('favorite-offers');
        }
        else if (dataUrlVal.indexOf("safety-sense") >= 0) {
          $(this).addClass('toyota-safety-sense');
        }
        else if (dataUrlVal.indexOf("toyota-care") >= 0) {
          $(this).addClass('toyota-care');
        }
        else if (dataUrlVal.indexOf("college-graduate") >= 0) {
          $(this).addClass('college-grad-rebate');
        }
        else if (dataUrlVal.indexOf("tools") >= 0) {
          $(this).addClass('shopping-tools');
        }
        else if (dataUrlVal.indexOf("compare") >= 0) {
          $(this).addClass('compare');
        }
        else if (dataUrlVal.indexOf("what-fits-my-budget") >= 0) {
          $(this).addClass('what-fits-my-budget');
        }
        else if (dataUrlVal.indexOf("configurator") >= 0) {
          $(this).addClass('build-price');
        }
        else if (dataUrlVal.indexOf("instagram") >= 0) {
          $(this).addClass('instagram');
        }
        else if (dataUrlVal.indexOf("facebook") >= 0) {
          $(this).addClass('facebook');
        }
        else if (dataUrlVal.indexOf("twiiter") >= 0) {
          $(this).addClass('twiiter');
        }
        else if (dataUrlVal.indexOf("linkedin") >= 0) {
          $(this).addClass('linkedin');
        }
      }
    });

    // add class to element by key and title (using for icons on first level of expanded mobile navigation - type container)
    var $firstLevelExpNavMobCont = $('.main-mobile-nav-wrapper > .site-nav-expanded-menu > .site-nav-expanded-menu-content > .site-nav-link-container > .site-nav-link-type-container');
    $firstLevelExpNavMobCont.each(function() {
      var dataKeyVal = $(this).children('span').attr('data-key');
      var dataTitleVal = $(this).children('span').attr('data-title');
      if (dataKeyVal.toLowerCase().indexOf("compare") >= 0 || dataTitleVal.toLowerCase().indexOf("compar") >= 0) {
        $(this).addClass('compare');
      }
      else if (dataKeyVal.toLowerCase().indexOf("featured") >= 0 || dataTitleVal.toLowerCase().indexOf("featured") >= 0) {
        $(this).addClass('featured');
      }
    });

    if (this._options.tdaCode.toLowerCase() !== 'www') {
      this.hideGenericMsg();
    } else {
      this.checkGlobalNoticeCookie();
    }

    this._dispatch('onRendered');
  }
});

// Link Type Rendering
Navigation.registerLinkTypeRenderer = function (type, fn) {
  if (typeof fn == 'string') {
    // The passed argument is a handlebars template, compile it
    fn = Handlebars.compile(fn);
  }

  // Store the reference
  __linkTypeRenderers[type] = fn;
};

Navigation.registerLinkTypeRenderer('link', txtLinkTypeLink);
Navigation.registerLinkTypeRenderer('container', txtLinkTypeContainer);

var __plugins = [];

Navigation.registerPlugin = function (plugin) {
  __plugins.push(plugin);
};

// This is an easy area to extend the navigation menus with enhanced features
Navigation.Plugin = function (nav, options) {
  this._nav = nav;
  this._options = options;
  this.initialize(nav, options);
};

$.extend(Navigation.Plugin.prototype, {
  initialize: function (navigation, options) {},
  bindEvents: function () {},
  getNavigation: function () { return this._nav; },
  getOptions: function () { return this._options; },
  onModelLoaded: function (model) {},
  onRendered: function () {},
});

Navigation.Plugin.extend = extend;

export default Navigation;

